import { call, delay, put, takeLatest } from 'redux-saga/effects';

import {
  deleteSMCCarsError,
  deleteSMCCarsRequest,
  deleteSMCCarsSuccess,
  getSMCCarsError,
  getSMCCarsSuccess,
  postAddSMCCarsError,
  postAddSMCCarsRequest,
  postAddSMCCarsSuccess,
} from './actions';
import { DELETE_SMC_CARS_REQUEST, GET_SMC_CARS_REQUEST, POST_ADD_SMC_CARS_REQUEST } from './constants';
import { smcCarsService } from './service';
import { clearError } from '../../../../common/FillTrip';

function* getSMCCarsRequestSaga() {
  try {
    // @ts-ignore
    const response = yield call(smcCarsService.getSMCCars);

    yield put(getSMCCarsSuccess(response));
  } catch (error: any) {
    yield put(getSMCCarsError(error));
  }
}

function* postAddSMCCarsRequestSaga(action: ReturnType<typeof postAddSMCCarsRequest>) {
  try {
    // @ts-ignore
    const response = yield call(smcCarsService.addSMCCars, action.payload);

    yield put(postAddSMCCarsSuccess(response));
  } catch (error: any) {
    yield put(postAddSMCCarsError(error.errorExtraParams));
    yield delay(7000);
    yield put(clearError());
  }
}

function* deleteSMCCarsRequestSaga(action: ReturnType<typeof deleteSMCCarsRequest>) {
  try {
    // @ts-ignore
    yield call(smcCarsService.deleteSMCCars, action.payload);

    yield put(deleteSMCCarsSuccess());
  } catch (error: any) {
    yield put(deleteSMCCarsError(error));
  }
}

export function* smcCarsSagaWatcher() {
  yield takeLatest(GET_SMC_CARS_REQUEST, getSMCCarsRequestSaga);
  yield takeLatest(POST_ADD_SMC_CARS_REQUEST, postAddSMCCarsRequestSaga);
  yield takeLatest(DELETE_SMC_CARS_REQUEST, deleteSMCCarsRequestSaga);
}
